<template>
  <layout-content>
    <tabs
      type="card"
      :animated="false"
      :value="$route.params.type"
      @on-click="$router.push({ to: 'mailer.stats.type', params: { type: $event } })"
    >
      <tab-pane
        v-for="tab in ['general', 'detailed']"
        :key="tab"
        :name="tab"
        :label="$t(`shared.breadcrumb.stats.${tab}`)"
      />
    </tabs>

    <component :is="`stats-${$route.params.type}`" />
  </layout-content>
</template>

<script>
  import { mapActions } from 'vuex';

  /**
   * TODO :: Для детальной статы должна быть кнопка экспорта
   * Она должна отображаться только если $permissions.service_mailing_detail_stats_export_is_allowed
   */

  export default {
    components: {
      'stats-general': () => import('@voice/components/voice-stats-general'),
      'stats-detailed': () => import('@voice/components/voice-stats-detailed')
    },

    watch: {
      '$route.params.type': {
        handler: function() {
          this.add_breadcrumbs({
            item: {
              title: `shared.breadcrumb.stats.${this.$route.params.type}`,
              route: {
                name: 'voice.stats.type',
                params: { type: this.$route.params.type }
              }
            }
          });
        },

        immediate: true
      }
    },

    methods: {
      ...mapActions('shared/breadcrumbs', { add_breadcrumbs: 'add_item' })
    }
  };
</script>
